<template>
  <div>
    <Modal v-model="setModal" title="新建员工" :mask-closable="false">
      <Form
        ref="setModelFrom"
        :model="modelData"
        :rules="ruleDate"
        :label-width="130"
      >
        <FormItem label="姓名：" prop="staffName">
          <Input v-model="modelData.staffName"></Input>
        </FormItem>
        <FormItem label="手机号：" prop="mobile">
          <Input v-model="modelData.mobile"></Input>
        </FormItem>
        <FormItem label="性别：" prop="gender">
          <Select v-model="modelData.gender">
            <!-- <Option
              v-for="item in roleList"
              :value="item.id"
              :key="item.name"
              >{{ item.name }}</Option
            > -->
            <Option value="1">男</Option>
            <Option value="2">女</Option>
          </Select>
        </FormItem>
        <FormItem label="角色：" prop="roleId">
          <Select v-model="modelData.roleId">
            <Option
              v-for="item in roleList"
              :value="item.id"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="入职时间：">
          <DatePicker
            format="yyyy-MM-dd"
            style="width: 100%"
            type="date"
            placeholder="请选择入职时间"
            v-model="modelData.entryTime"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer" class="footer">
        <Button type="error" :loading="addLoading" @click="addSave()"
          >确定</Button
        >
        <Button type="default" @click="cancel()" style="background: #fff;color:#377CF1;margin-right: 120px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  addStaff,
  getVerification
} from '@/api/myweb/organization/staffManagement'
import { saveContact } from '@/api/myweb/organization/linkmanManagement'
import { dataMixin } from './datamixin.js'
export default {
  mixins: [dataMixin],
  props: {
    statusList: {
      type: Array,
      default: () => {}
    }
  },
  created() {},
  data() {
    //  逻辑手机号检测
    // const isTel = (rule, value, callback) => {
    //   // let reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
    //   let reg = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\d])|(18[0-9]))\d{8}$/
    //   // 验证手机号是否符合正则
    //   if (!value) {
    //     callback(new Error('不能为空！'))
    //   }
    //   // 被点击后
    //   if (this.isTel) {
    //     if (!reg.test(value)) callback(new Error('请输入正确的手机号'))
    //     else {
    //       callback()
    //     }
    //   } else {
    //     callback()
    //   }
    // }
    //   验证码
    // const isVerificationCode = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('不能为空！'))
    //   } else {
    //     callback()
    //   }
    // }
    // 账号
    // const isUsername = (rule, value, callback) => {
    //   let reg = /^[a-zA-Z0-9_]*$/g
    //   // 验证账号是否符合正则
    //   if (!value) {
    //     callback(new Error('不能为空！'))
    //     return
    //   }
    //   if (!reg.test(value)) {
    //     callback(new Error('账号必须是字母、数字、下划线'))
    //   } else {
    //     callback()
    //   }
    // }
    // 姓名
    // const isStaffName = (rule, value, callback) => {
    //   let reg = /^[\u4e00-\u9fa5]{0,}$/g
    //   // 验证账号是否符合正则
    //   if (!value) {
    //     callback(new Error('不能为空！'))
    //     return
    //   }
    //   if (!reg.test(value)) {
    //     callback(new Error('员工姓名必须为中文'))
    //   } else {
    //     callback()
    //   }
    // }
    // 密码
    // const isPwd = (rule, value, callback) => {
    //   let reg = /^[a-zA-Z0-9]*$/g

    //   if (!value) {
    //     callback(new Error('不能为空！'))
    //     return
    //   }
    //   if (!reg.test(value)) {
    //     callback(new Error('密码必须是字母、数字'))
    //   } else {
    //     callback()
    //   }
    // }
    // 确认密码
    // const comfirmPwd = (rule, value, callback) => {
    //   // 验证密码是否相同
    //   if (value !== this.modelData.password) {
    //     callback(new Error('确认密码与密码不同'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      modelData: {
        mobile: '',
        staffName: '',
        gender: '1',
        entryTime: '',
        roleId: ''
      },
      setModal: false,
      addLoading: false,
      buttonText: '获取验证码',
      disabled: false, // 验证码按钮是否禁用
      isTel: false, // 是否点击获取验证码（tel正则）
      iseye: {
        isPwd: false,
        passwords: false
      },
      roleList: [],
      ruleDate: {
        staffName: [
          {
            required: true,
            message: '员工姓名不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            max: 20,
            message: '最多输入20个字',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        roleId: [
          {
            required: true,
            message: '角色不能为空',
            trigger: 'blur'
          }
        ],
        gender: [
          {
            required: true,
            message: '性别不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    getData() {
      this.$refs.setModelFrom.resetFields()
      console.log(this.statusList)
      this.getRoleList()
      this.setModal = true
    },
    addSave() {
      this.$refs.setModelFrom.validate(async (valid) => {
        if (valid) {
          console.log(this.modelData)
          let data = JSON.parse(JSON.stringify(this.modelData))
          data.entryTime = data.entryTime.substr(0, 10)
          this.addLoading = true
          let res = await addStaff(data)
          console.log(res)
          if (res.status) {
            this.$Message.success('保存成功!')
            this.setModal = false
            this.$parent.getStaffList()
          } else {
            // this.$Message.error(res.message)
          }
        } else {
          this.$Message.error('您有必填信息还未填写')
        }
        this.addLoading = false
      })
      // this.$emit('getStaffList')
    },
    cancel() {
      this.setModal = false
    }
  }
}
</script>

<style lang="less" scoped>
// /deep/.ivu-form-item-error-tip {
//   top: 20%;
//   left: 100px;
// }
.ivu-form-item-content {
  position: relative;
}
.eyeIcon {
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;
}
/deep/.ivu-modal-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  .ivu-modal {
    top: 0;
  }
}




//修改弹窗按钮
.footer{
  Button{
    width: 80px;
    height: 30px;
    background: #377CF1;
    opacity: 1;
    border-radius: 2px;
    border:1px solid #377CF1;
    text-align: center;
  }
}
//修改弹框
 /deep/ .ivu-modal-content {
 padding-bottom: 10px;
  width: 450px;
  height: 360px;
  position: relative;
  background-color: #fff;
  border: 0;
  border-radius: 0px !important;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
}
//修改弹框X
/deep/ .ivu-modal-close {
    z-index: 1;
    font-size: 10px;
    position: absolute;
    right: 8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    top: 10px;
    background-color: #BBBBBB;
    overflow: hidden;
    cursor: pointer;
}
/deep/ .ivu-modal-close .ivu-icon-ios-close {
    font-size: 30px;
    color: #fbfbfb;
    top: -4px;
    left: -4.5px;
}
//修改弹窗头部
/deep/ .ivu-modal-header {
    border-bottom: 1px solid #e8eaec;
    padding: 10px 16px !important;
    line-height: 1;
    background: #F0F0F0;
}
/deep/ .ivu-modal-header-inner {
    display: inline-block;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #555555;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 1;
}
//修改弹窗文本框宽度修改
/deep/ .ivu-input-wrapper {
    width: 323px;
    height: 30px !important;
}
//修改弹窗文本间距修改
/deep/ .ivu-form-item {
    margin-bottom: 18px !important;
    padding-left: 10px;
}
//修改弹窗下拉框宽度修改
/deep/ .ivu-select {
    width: 323px !important;
}
/deep/ .ivu-modal-body {
  margin-top:10px;
  padding: 0px !important;
}
/deep/.ivu-input {
    height: 30px !important;
}
//修改弹窗按钮边距
/deep/ .ivu-modal-footer {
    padding: 10px 18px 12px 18px !important;
}
//修改弹窗文本框边距
/deep/ .ivu-form-item-content {
    margin-left: 87px !important;
}
//修改弹窗文本框边距
/deep/ .ivu-form .ivu-form-item-label {
    color: #505050;
    width: 87px !important;
    font-family: Source Han Sans CN;
    font-weight: 400;
}
</style>
